import { ReactElement } from "react";
import clsx from "clsx";

export function Divider({ className }: { className?: string }): ReactElement {
  return <div className={clsx("h-px w-full bg-white bg-opacity-10", className)}></div>;
}
